import React from "react";
import PropTypes from "prop-types";
import { component_tool, framework_tool } from "@/tool";
const { WizContainer } = framework_tool;
const { WizButton } = component_tool;
import { Table, Form } from "antd";
import { WizTableForm } from "@/containers/common";
import columns from './columns'
import "./index.less";

class EditTable extends WizContainer {
  componentName = "EditTable";

  constructor(props) {
    super(props);
    this.state = {
      value: props.value || [],
      record: {},
      dataSource:  [],
      count: 0
    }
  }

  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func,
  };

  _componentDidMount(){
    const { onChange } = this.props
    const { value } = this.state
    if(!value.length) return
    const val = [ ...value ].map(val=>{
      return {
        key: val.templateId,
        templateId: val.templateId,
        templateName: val.templateName,
        positionRows: val.positionRows.map(val => { return { id: val.positionId, name: val.positionName } }),
        positionIds: val.positionRows.map(val=> val.positionId),
        positionNames: val.positionRows.map(val=><span key={ val.positionId } className="position-label"> { val.positionName } </span>)
      }
    })
    this.setState({
      dataSource: val
    },()=>{
      const vals = this.formatVals(this.state.dataSource)
      onChange && onChange(vals)
    })
  }

  // 生命周期钩子函数
  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  // 过滤“关联考试模版”的值
  formatVals = vals => {
    return vals
    // if(vals && vals.length){
    //   return vals.filter(val => val.templateName !== '请选择考试模版').filter(val => val.positionNames !== '请选择岗位对象')
    // }
    // return []
  }

  // 删除行
  handleDelete = key => {
    const { onChange } = this.props
    const dataSource = [...this.state.dataSource];
    this.setState({
      dataSource: dataSource.filter((item) => item.key !== key),
    },()=>{
      const vals = this.formatVals(this.state.dataSource)
      onChange && onChange(vals)
    });
  };

  // 添加行
  handleAdd = () => {
    const { onChange } = this.props
    const { count, dataSource } = this.state;
    const newData = {
      key: count,
      templateName: "请选择考试模版",
      positionNames: "请选择岗位对象",
      status: 1,
      statusName: '有效'
    };
    this.setState({
      dataSource: [...dataSource, newData],
      count: count + 1
    },()=>{
      const vals = this.formatVals(this.state.dataSource)
      onChange && onChange(vals)
    });
  };

   // 修改行状态
   handleChangeStutas = (key,status) => {
    const { onChange } = this.props
    const dataSource = [...this.state.dataSource];
    this.state.dataSource.forEach((e)=>{
        if(e.key === key){
          e.status = status;
          if(status === 0){
            e.statusName = '无效'
          }else{
            e.statusName = '有效'
          }
        }
    })
    this.setState({
      dataSource: dataSource,
    },()=>{
      const vals = this.formatVals(this.state.dataSource)
      onChange && onChange(vals)
    });
  };

  // 保存行数据
  handleSave = row => {
    const newData = [...this.state.dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    this.setState({
      dataSource: newData
    });
  };

  _render() {
    const { dataSource } = this.state;
    const { apiParams } = this.props;
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };
    const cols = columns(this, this.handleDelete,this.handleChangeStutas).map((col) => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: record => ({
          record,
          apiParams,
          dataSource,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
          formatVals: this.formatVals,
          onChange: this.props.onChange,
        }),
      };
    });
    return (
      <React.Fragment>
        <Table
          size="middle"
          components={components}
          rowClassName={() => "editable-row"}
          bordered={false}
          dataSource={dataSource}
          columns={cols}
          style={{ marginBottom: 10 }}
        />
        <WizButton icon="plus" type="primary" onClick={() => this.handleAdd()}>
          添加
        </WizButton>
      </React.Fragment>
    );
  }
}

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing });
  };

  onChangeRowMap = (rows, flag) => {
    const { record, handleSave, onChange, dataSource, formatVals } = this.props;
    const editing = !this.state.editing;
    const values = { ...record }

    if(flag) { //考试模版名称
      const template = Object.values(rows)[0]
      values.templateId = template.id
      values.templateName = template.title
    }else{  //岗位对象
      const position = Object.values(rows)
      values.positionIds = position.map(val => val.id)
      values.positionNames = position.length ? position.map(val => <span key={ val.id } className="position-label"> { val.name } </span>) : '请选择岗位对象'
      values.positionRows = position.map(val => { return { id: val.id, name: val.name } })

    }
    this.setState({ editing });
    const filterValues = dataSource.filter(val => val.key !== values.key)
    handleSave({ ...record, ...values });
    const vals = formatVals([ ...filterValues, { ...record, ...values } ])
    if(vals.length){
      onChange && onChange(vals)
    }
  };

  renderCell = (form) => {
    this.form = form;
    const { children, dataIndex, record, title, apiParams } = this.props;
    const { editing } = this.state;
    let flag = dataIndex === "templateName";  //考试模版选择
    const wizTableFormProps = {
      key: record.key,
      title,
      visible:true,
      selectType: flag ? "radio" : "checkbox",
      initRows: flag ? [{ id: record.templateId, name: record.templateName }]: record.positionRows,
      placeholder: `请选择${flag ? "考试模版" : "岗位对象"}`,
      onChangeRowMap: rows => this.onChangeRowMap(rows, flag),
      onCancel: () => { this.setState({ editing: !editing }) },
      ...WizTableForm.Config[flag ? "examTemp" : "position"](this, { apiParams: {state:1,...apiParams} })
    };

    return editing ? (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          initialValue: flag ? record.templateId: record.positionIds,
          rules: [
            {
              required: true,
              message: `${flag ? "考试模版" : "岗位对象"} 不能为空`
            },
          ],
          // initialValue: record[dataIndex]
        })(
          <WizTableForm {...wizTableFormProps }/>
        )}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      dataSource,
      index,
      handleSave,
      formatVals,
      onChange,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

EditTable.validator = (rule, value, callback) => {
  if (value && value.length) {
    value.forEach(data => {
      if (!data.templateId) {
        callback('请选择考试模版')
        return
      }
      if (!(data.positionIds && data.positionIds.length)) {
        callback('请选择岗位对象')
        return
      }
    })
  }
  callback()
}

export default EditTable
